<template>


    <div class="vote-screen">
        <giveawayModal :settings="giveawayModalSettings"></giveawayModal>
        <div class="page-spinner">
            <b-spinner v-if="signInLoading" style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
        </div>

        <div
                v-bind:class="' face-rate' + ' option-' + rate_id + [rate_id ? ' selected' : '']"
                v-bind:style="{ filter: [signInLoading ? 'blur(10px)' : 'none']}"
        >
            <profileIcon></profileIcon>
            <div class="logo" @click="homePage">
                <img alt="logo" src="../assets/icons/logo_mini.svg" class="bad">
            </div>

            <div class="place">
                <div class="place_img" @click="onPlaceImageClick()">
                    <img v-if="place_img.length != 0" :src="place_img" alt="place img">
                    <img v-else src="../assets/re/default_place_img.jpg" alt="place img">
                </div>
                <div class="place_name" @click="onPlaceNameClick()">{{place_info.place.name}}</div>
            </div>
            <div class="question" @click="onQuestionNameClick()">{{place_info.question}}</div>

            <div class="push_rate">
                <ul v-bind:class="[sendRateClass ? 'disable-class' : '']">
                    <li v-bind:class="'cool ' + [rate_id == '3' ? 'active' : '']">
                        <a @click="changeRateRote(3)">
                            <img alt="logo" src="../assets/re/smile/cool.png">
                        </a>
                    </li>
                    <li v-bind:class="'soso ' + [rate_id == '2' ? 'active' : '']">
                        <a @click="changeRateRote(2)">
                            <img alt="logo" src="../assets/re/smile/soso.png">
                        </a>
                    </li>
                    <li v-bind:class="'meh ' + [rate_id == '1' ? 'active' : '']">
                        <a @click="changeRateRote(1)">
                            <img alt="logo" src="../assets/re/smile/meh.png">
                        </a>
                    </li>
                </ul>
            </div>

            <div class="success-message">
                <div class="success-text">{{ translate('voteSuccessText_1') }}</div>
                <div class="success-text-secondary">{{ translate('voteSuccessText_2') }}</div>
                <div class="success-text-secondary">{{ translate('voteSuccessText_3') }}</div>
            </div>

            <div class="bottom-button-group">

                <div class="comment-wrap">
                    <button class="comment-button primaryButton block reverse" @click="openCommentModal">
                        <svg class="comment-icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <!-- Generator: sketchtool 61.1 (101010) - https://sketch.com -->
                            <title>458AE8E0-3E77-432E-AA34-1622A828C787</title>
                            <desc>Created with sketchtool.</desc>
                            <defs>
                                <path d="M17.3333698,5 C17.5937766,5 17.847027,5.0761564 18.0664337,5.22037543 C18.1699339,5.28875056 18.2272465,5.4088758 18.2142153,5.53256354 C18.2018402,5.65593878 18.1217776,5.76237649 18.0065274,5.80828283 C17.7532769,5.90918928 17.5325577,6.05275206 17.3502761,6.23537741 L17.3502761,6.23537741 L15.1871468,8.39819414 C15.1331155,8.36044406 15.0709904,8.33338151 15.0000215,8.33338151 L15.0000215,8.33338151 L7.66666341,8.33338151 C7.48241305,8.33338151 7.33331901,8.48247555 7.33331901,8.66672591 C7.33331901,8.85097627 7.48241305,9.00007031 7.66666341,9.00007031 L7.66666341,9.00007031 L14.5851457,9.00007031 L13.2929557,10.2920728 C13.2806744,10.3044166 13.2739244,10.3205729 13.2623306,10.3334167 L13.2623306,10.3334167 L7.66666341,10.3334167 C7.48241305,10.3334167 7.33331901,10.4825107 7.33331901,10.6667611 C7.33331901,10.8510114 7.48241305,11.0001055 7.66666341,11.0001055 L7.66666341,11.0001055 L12.9802363,11.0001055 L12.6862357,12.4708271 C12.6204856,12.7989527 12.7227045,13.1368284 12.9596737,13.3741414 C13.1947055,13.6088606 13.5306436,13.7143295 13.8626755,13.6472669 L13.8626755,13.6472669 L15.529335,13.3139225 C15.7226791,13.2751724 15.8997732,13.1807972 16.0397423,13.0404845 L16.0397423,13.0404845 L18.0976838,10.9831992 C18.1927465,10.8877927 18.3366218,10.8591677 18.4609657,10.9109178 C18.5853097,10.9623554 18.6667161,11.0841056 18.6667161,11.2188559 L18.6667161,11.2188559 L18.6667161,15.0001133 C18.6667161,15.7354897 18.0684025,16.3334596 17.3333698,16.3334596 L17.3333698,16.3334596 L7.80469493,16.3334596 L4.56900111,19.5691535 C4.50518849,19.6329661 4.41990707,19.6668099 4.33331315,19.6668099 C4.29034432,19.6668099 4.24675048,19.6586536 4.20571915,19.6414036 C4.08137516,19.589966 4,19.468247 4,19.3334655 L4,19.3334655 L4,6.3334401 C4,5.59809492 4.59831367,5 5.33334635,5 L5.33334635,5 Z M18.7239975,6.3334401 C19.4277801,6.3334401 20,6.90572247 20,7.60947385 C20,7.9450995 19.8639372,8.27388139 19.6263118,8.51150686 L19.6263118,8.51150686 L15.5683663,12.5691085 C15.5221475,12.6156711 15.4628974,12.6472337 15.3978035,12.660265 L15.3978035,12.660265 L13.731769,12.9936094 C13.7103002,12.9978281 13.6881752,13.0001094 13.6666751,13.0001094 C13.579425,13.0001094 13.4941435,12.9656093 13.4309872,12.9024529 C13.3522058,12.8237028 13.3177057,12.7107338 13.3398307,12.6013586 L13.3398307,12.6013586 L13.6731751,10.9340428 C13.6862064,10.869574 13.7174565,10.8103551 13.7643316,10.7637925 L13.7643316,10.7637925 L17.821652,6.70712833 C18.0586212,6.46984662 18.3874031,6.3334401 18.7239975,6.3334401 Z M11.6666712,12.3334206 L7.66666341,12.3334206 C7.48241305,12.3334206 7.33331901,12.4825146 7.33331901,12.666765 C7.33331901,12.8510153 7.48241305,13.0001094 7.66666341,13.0001094 L7.66666341,13.0001094 L11.6666712,13.0001094 C11.8509216,13.0001094 12.0000156,12.8510466 12.0000156,12.666765 C12.0000156,12.4825146 11.8509216,12.3334206 11.6666712,12.3334206 L11.6666712,12.3334206 Z M17.8045582,7.66663021 L17.3332135,8.13797488 L18.195309,9.00007031 L18.6667161,8.52878814 L17.8045582,7.66663021 Z"
                                      id="path-1"></path>
                            </defs>
                            <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="icon-icons/ic_feedback">
                                    <mask id="mask-2" fill="white">
                                        <use xlink:href="#path-1"></use>
                                    </mask>
                                    <use id="Combined-Shape" fill="#3F405C" fill-rule="nonzero"
                                         xlink:href="#path-1"></use>
                                </g>
                            </g>
                        </svg>
                        <span>{{ translate('writeFeedBack') }}</span>
                    </button>
                </div>

                <socialReviewBtnFlow :settings="socialReviewBtnFlowSettings"
                                     :state="showSocialReviewPopup"
                                     class="socialReviewBtnFlow"></socialReviewBtnFlow>
            </div>

            <giveawayBottomBlock :settings="giveawayBottomBlockSettings"
                                 class="giveawayBottomBlock"></giveawayBottomBlock>

        </div>

        <!-- Comment modal -->
        <b-modal v-model="commentModal" :content-class="'custom-modal'">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="cancelCommentModal"></span>
            </template>

            <div class="note-icon-wrap">
                <span class="note-icon"></span>
            </div>
            <h2 class="note-title">{{ +this.rate_id === 3 ? translate('feedbackTitle') : +this.rate_id === 2 ? translate('feedbackTitleSoSo') : translate('feedbackTitleSad') }}</h2>
            <div class="note-subtitle">({{translate('feedbackSubtitle')}})</div>

            <md-field :class="this.$ml.current">
                <label>{{ translate('yourNote') }}</label>
                <md-textarea v-model="commentText" :maxlength="200"></md-textarea>
            </md-field>

            <div class="feedback-wrapper">
                <label>
                    <b-form-checkbox v-model="feedbackBlock">
                        <span class="feedback-text">{{translate('feedbackText')}}</span>
                    </b-form-checkbox>
                </label>
                <div class="feedback-input" v-if="feedbackBlock == true">
                    <md-field>
                        <label>{{translate('commentPopupEmail')}}</label>
                        <md-input type="email" v-model="feedbackEmail"></md-input>
                        <span class="md-helper-text">{{translate('feedbackHelpText')}}</span>
                    </md-field>
                </div>
            </div>

            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="cancelCommentModal">
                    {{ translate('Cancel') }}
                </b-button>

                <b-button variant="primary" :disabled="loadingAction" @click="onSaveComment()">
                    <b-spinner v-if="loadingAction" small></b-spinner>
                    {{ translate('Submit') }}
                </b-button>

            </template>

        </b-modal>


    </div>

</template>

<script>

    import Vue from 'vue'
    import {MdField} from 'vue-material/dist/components'
    import facebookLogin from 'facebook-login-vuejs';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import {isValidUrl} from '@/helpers/customValidators'
    import rateMixin from '@/mixins/rateMixin';
    import errorMixin from '@/mixins/errorMixin';
    import logAnalyticsEvent, {logError} from '@/helpers/analytics'
    import config from '@/api/config';
    import giveawayModal from "./widgets/giveawayModal";
    import giveawayBottomBlock from "./widgets/giveawayBottomBlock";
    import profileIcon from "./voteFlow/widgets/profileIcon.vue";
    import socialReviewBtnFlow from "./voteFlow/widgets/socialReviewBtnFlow.vue";

    Vue.use(MdField)

    export default {
        name: 'AirVote',
        components: {giveawayModal, giveawayBottomBlock, profileIcon, socialReviewBtnFlow},
        comments: {
            facebookLogin,
            giveawayModal
        },
        mixins: [mixin, errorMixin, rateMixin],
        data() {
            return {
                commentText: '',
                loadingAction: false,
                commentModal: false,
                socialModal: false,
                signInLoading: false,
                feedbackBlock: false,
                feedbackEmail: '',
                place_img: '',
                place_info: {
                    place: {
                        name: '',
                    },
                    question: ''
                },
                currentVote: null,
                voteBoll: true,
                question_id: this.$route.params.id,
                rate_id: this.$route.params.number,
                successRegistration: false,
                sendRateClass: false,
                rateMessage: '',
                personalID: 0,
                email: '',
                name: '',
                thanksReplaceRoute: '/thank-for-vote/',
                giveawayModalSettings: null,
                giveawayBottomBlockSettings: {
                    openGiveawayModal: this.showGiveawayPopup.bind(null)
                },
                showSocialReviewPopup: false,
            }
        },
        watch: {
            isAuthorized(newValue) {
                if (!newValue) {
                    this.$store.commit('rate/clearGiveaway')
                }
            },
            'rate_id'(newValue) {
                this.$store.commit('rate/setRateValue', newValue)
            },
        },
        props: {
            msg: String
        },
        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                anonymousToken: state => state.auth.anonymousToken,
                voted: state => state.voted,
            }),

            ...mapGetters({
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                isUserClient: 'auth/isUserClient',
                hasOwnPlace: 'auth/hasOwnPlace',
                isAuthorized: 'auth/isAuthorized',
                giveaway: 'rate/getGiveaway',
                userInfo: 'auth/getUserInfo',
            })
        },
        async mounted() {
            this.question_id = this.$route.params.id;
            this.rate_id = this.$route.params.number;
            await this.getRateInfo(this.question_id)
            this.$store.commit('rate/setRateValue', this.$route.params.number)
            console.log(this.place_info)
            if (performance.navigation.type !== 1) {

                if (this.place_info.place !== null) {
                    this.showCommentPopupIfNeed()
                    try {
                        if (this.accessToken) {
                            const response = await this.sendRate({
                                userStatus: '/api/v1/sendRate',
                                question_id: this.question_id,
                                index: this.rate_id
                            })
                            this.currentVote = response.data
                            this.$store.commit('rate/setRateUid', response.data.uid)
                        } else {
                            const response = await this.sendRate({
                                userStatus: '/api/sendRateWithoutAuth',
                                question_id: this.question_id,
                                index: this.rate_id
                            })
                            this.currentVote = response.data
                            this.$store.commit('rate/setRateUid', response.data.uid)
                        }
                        this.setVotedState(true)
                        this.updateUrl()
                    } catch (error) {
                        this.showErrorModal(error.data.error.message)
                    }
                }
            } else {
                this.$router.push({
                    name: 'ThanksCreateNote',
                    params: {questionId: this.question_id, number: this.rate_id, rateUid: this.currentVote.uid}
                })
            }

        },
        methods: {
            ...mapActions({
                sendRate: 'rate/sendRate',
                sendSocialClick: 'rate/sendSocialClick',
                changeRate: 'rate/changeRate',
                fetchUserInfo: 'auth/fetchUserInfo',
                createComment: 'comment/createComment',
            }),

            ...mapMutations({
                setVotedState: 'setVotedState',
                removeKeys: 'auth/removeKeys',
            }),

            openSocialLink(link) {
                logAnalyticsEvent('vote_screen_soc_review_item_click')
                this.sendSocialClickToServer(this.currentVote.uid, link.uid)
                window.open(link.url, '_blank');
            },

            onPlaceNameClick() {
                logAnalyticsEvent('vote_screen_place_title_click')
                this.openSiteUrl()
            },

            onPlaceImageClick() {
                logAnalyticsEvent('vote_screen_place_img_click')
                this.openSiteUrl()
            },

            openSiteUrl() {
                let url = this.place_info.place.site_url
                if (isValidUrl(url)) {
                    window.open(url, '_blank')
                }
            },

            onQuestionNameClick() {
                logAnalyticsEvent('vote_screen_question_title_click')
            },

            async onSaveComment() {
                if (this.commentText.length == 0 && this.feedbackEmail.length == 0) {
                    logAnalyticsEvent('vote_screen_comment_dlg_send_empty_clck')
                    this.commentModal = false
                    return
                }
                console.log('onSaveComment');
                logAnalyticsEvent('vote_screen_comment_dialog_send_click')
                try {
                    this.loadingAction = true
                    await this.createComment({
                        voteId: this.currentVote.uid,
                        commentText: this.commentText,
                        feedbackEmail: this.feedbackEmail
                    })
                    this.commentText = ''
                    this.commentModal = false
                    logAnalyticsEvent('vote_screen_comment_dialog_sent_success')
                    this.goToThankForVote()

                } catch (error) {
                    console.log('error', error)
                    logAnalyticsEvent('vote_screen_comment_dialog_sent_error', {
                        msg: error.data.error.message
                    })
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingAction = false
                }
            },
            homePage() {
                window.open(`${config.siteUrl}/${this.$ml.current}`, '_blank').focus()
            },

            goToThankForVote() {
                this.$router.push({
                    name: 'ThanksCreateNote',
                    params: {questionId: this.question_id, number: this.rate_id, rateUid: this.currentVote.uid}
                })
            },

            showCommentPopupIfNeed() {
                try {
                    if (+this.rate_id !== 3) {
                        this.commentModal = true
                    }
                } catch (e) {
                    logAnalyticsEvent('showCommentPopupIfNeed_Error')
                }
                try {
                    this.showSocialReviewPopup = (+this.rate_id === 3) && this.hasDonateLinks()
                } catch (e) {
                    logAnalyticsEvent('showSocialReviewPopup_Error')
                }
            },

            hasDonateLinks() {
                return this.place_info.place.links.find(item => item.network.alias == 'donate' || item.network.alias == 'adopt') != null
            },

            async changeRateRote(id) {
                if (this.rate_id != id) {
                    let rateValue
                    if (+id === 1) rateValue = 'sad'
                    if (+id === 2) rateValue = 'ok'
                    if (+id === 3) rateValue = 'happy'

                    logAnalyticsEvent('vote_screen_change_vote', {
                        value: rateValue
                    })

                    try {
                        this.signInLoading = true
                        await this.changeRate({
                            changeRateID: this.currentVote.uid,
                            rate: id
                        })
                    } catch (error) {
                        this.showErrorModal(error.data.error.message)
                    } finally {
                        this.rate_id = id;
                        this.signInLoading = false
                        this.showCommentPopupIfNeed()
                        this.updateUrl()
                    }
                }
            },

            updateUrl() {
                history.replaceState(
                    {},
                    null,
                    location.origin + this.thanksReplaceRoute + this.question_id + '/' + this.rate_id + '/' + this.currentVote.uid + `?ouid=${this.place_info.org_uid}&r=${this.rate_id}`
                )
            },

            openCommentModal() {
                logAnalyticsEvent('vote_screen_comment_btn_click')
                this.commentModal = true
            },
            cancelCommentModal() {
                logAnalyticsEvent('vote_screen_comment_dialog_cancel')
                this.commentModal = false
                this.commentText = ''
            },

            showGiveawayPopup() {
                this.giveawayModalSettings = {
                    showCancelButton: false,
                    hideOkButton: true,
                    place_info: this.place_info,
                    currentVoteUid: this.currentVote.uid,
                    question_id: this.question_id,
                }
            },

            async pushRate(index, social) {
                this.sendRateClass = true;

                console.log('currentVote', this.currentVote)
                try {
                    await this.changeRate({
                        changeRateID: this.currentVote.uid,
                        rate: index
                    })
                    switch (social) {
                        case 'google': {
                            this.GoogleSignIn({becomeOwner: false});
                            break;
                        }
                        case 'facebook': {
                            this.FacebookSignIn({becomeOwner: false});
                            break;
                        }
                        case 'login': {
                            this.$router.push({
                                name: 'Login',
                                params: {
                                    mgs: this.translate('Thank_for_vote')
                                }
                            });
                            break;
                        }
                        default : {
                            this.goToThankForVote()
                        }
                    }
                    this.setVotedState(true)
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },

        },


    }
</script>


<style>

    .custom-modal.social-modal .primaryButton {
        margin-bottom: 8px;
        border-radius: 4px;
    }

    .custom-modal.social-modal .primaryButton.facebook-button {
        background: #1976D2;
    }

    .custom-modal.social-modal .primaryButton.yelp-button {
        background: #FE5022;
    }

    .custom-modal.social-modal .primaryButton.google-button {
        background: #5D8FF1;
    }

    .custom-modal.social-modal .primaryButton.tripAdvisor-button {
        background: #51B18A;
    }

    .custom-modal.social-modal .primaryButton.instagram-button {
        background: #E1306C;
    }

    .custom-modal.social-modal .primaryButton.vk-button {
        background: #4c75a3;
    }

    .custom-modal.social-modal .primaryButton.website-button {
        background: #ffb12b;
    }

    .custom-modal.social-modal .primaryButton.donate-button {
        background: #00a99e;
    }

    .custom-modal.social-modal .primaryButton.adopt-button {
        background: #9d1c20;
    }

    .custom-modal .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding: 0;
        padding-top: 10px;
        border-bottom: 1px solid #333;
        margin-top: 10px;
    }

    .custom-modal .md-field.md-has-textarea:not(.md-autogrow) label {
        left: 0
    }

    .custom-modal .md-field.md-has-textarea:not(.md-autogrow) .md-count {
        bottom: -25px;
        text-align: left;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }

    .custom-modal .md-count:after {
        display: inline-block;
        margin-left: 8px;
        content: 'character used'
    }
    .custom-modal .uk .md-count:after {
        content: 'символів використано'
    }
    .custom-modal .ru .md-count:after {
        content: 'символов использовано'
    }

    .note-title {
        font-size: 18px;
        width: 100%;
        text-align: center;
        font-weight: bold;
    }

    .note-subtitle {
        font-size: 18px;
        font-weight: 500;
        font-weight: bold;
    }

    .note-description {
        font-size: 14px;
        line-height: 20px;
        margin: 15px 30px 24px;
        /*width: 100%;*/
        font-weight: 400;
        text-align: center;
    }

    .note-icon-wrap {
        margin-top: -25px;
        text-align: center;
        margin-bottom: 10px;
    }

    .note-icon {
        display: inline-block;
        width: 50px;
        height: 50px;
        background: url('../assets/icons/ic_comment_modal.svg') 50% no-repeat;
    }

    .giveawayBottomBlock {
        width: 100%;
        display: flex;
        justify-content: center;
        position: relative;
    }

    .socialReviewBtnFlow {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    @media screen and (max-width: 768px) {
        .custom-modal .modal-footer {
            flex-direction: column-reverse;
        }
        .custom-modal .btn {
            margin: 0;
        }
        .custom-modal .btn.btn-primary {
            margin-bottom: 8px;
            border: none;
        }
    }

    .md-textarea {
        font-size: 16px !important;
    }

</style>


<style scoped>

    .vote-screen,
    .face-rate {
        /*height: calc(var(--vh, 1vh) * 100);*/
    }

    .vote-screen {
        display: flex;
        flex-direction: row;
    }

    .face-rate {
        /*height: 100vh;*/
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        flex: 1 1;
        overflow: auto;
    }

    .logo {
        margin-top: 1em;
        text-align: center;
        margin-bottom: 15px;
    }

    .social {
        width: 100%;
        padding: 15px 10px;
        background: #F1F1F1;
        display: none;
    }

    .place_img {
        width: 6em;
        height: 6em;
        margin: 1em auto 1em;
        box-sizing: border-box;
        border-radius: 50%;
        filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.293679));
    }

    .place_img img {
        min-width: 6em;
        min-height: 6em;
        margin: 0 auto;
        border-radius: 50%;
        display: block;
        width: 100%;
        height: 100%;
    }

    .question {
        text-align: center;
        font-size: 1.2em;
        font-weight: 700;
        margin-left: 20px;
        margin-right: 20px;
    }
    .place_name {
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #6D6D6D;
        padding-top: 5px;
        margin-left: 20px;
        margin-right: 20px;
    }
    button.primaryButton.reverse {
        color: #3F405C;
        border: 2px solid #3F405C;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        min-height: 45px;
    }
    .md-field.md-has-textarea:not(.md-autogrow) label {
        top: 40px;
        left: 0px;
        font-size: 14px;
        font-weight: normal;
        color: #2F2F2F;
    }
    .md-field.md-has-textarea:not(.md-autogrow).md-has-value label {
        top: 15px;
    }
    .md-field.md-has-textarea:not(.md-autogrow).md-focused label, .md-field.md-has-textarea:not(.md-autogrow).md-has-value label {
        top: 10px;
    }
    .custom-modal .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        border-bottom: 2px solid #3F405C;
        border-radius: 1px;
        font-weight: 600;
    }
    .feedback-text {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        padding-left: 5px;
    }
    .custom-control-label {
        padding-top: 4px;
    }

    .custom-modal .btn.btn-primary {
        background-color: #3F405C;
    }
    .custom-modal .btn {
        border: 2px solid #3F405C;
        box-sizing: border-box;
        border-radius: 6px;
        margin-right: 5px;
    }
    .feedback-wrapper {
        background: #F3F3F3;
        border-radius: 4px;
        padding: 8px;
        display: flex;
        justify-content: start;
        align-items: start;
        flex-direction: column;
        margin-top: 35px;
    }
    .custom-control {
        line-height: 28px;
    }
    label {
        margin-bottom: 0;
    }
    .feedback-input {
        width: 100%;
        height: 100%;
    }
    .md-field:after {
        height: 2px;
    }
    .md-field.md-theme-default:after {
        background-color: #3F405C;
        border-radius: 1px;
    }
    .md-field label {
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #6D6D6D;
    }
    .md-helper-text {
        font-weight: normal;
        font-size: 14px !important;
        line-height: 20px;
    }


    .success-message {
        padding: 0 1em;
        /*flex: 1 1 30%;*/
    }

    .success-text {
        font-size: 20px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 5px;
    }

    .success-text-secondary {
        font-size: 16px;
        text-align: center;
    }

    .comment-wrap {
        /*margin-top: 20px;*/
        padding: 0 1em;
        width: 100%;
        max-width: 380px;
    }

    .bottom-button-group button {
        margin-top: 8px;
    }

    .comment-icon {
        display: inline-block;
        margin-right: 6px;
    }

    .question {
        display: flex;
        align-items: center;
        margin-top: .25em;
    }

    .push_rate ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 0.2em 0;
    }

    .push_rate ul li {
        margin: 0;
    }

    .push_rate ul li.active.cool {
        box-shadow: inset 0 0 0 0.35em #209400
    }

    .push_rate ul li.active.soso {
        box-shadow: inset 0 0 0 0.35em #ffc800
    }

    .push_rate ul li.active.meh {
        box-shadow: inset 0 0 0 0.35em #e01300
    }

    .push_rate ul li a {
        padding-top: 8px;
        width: 28vw;
        height: 28vw;
        max-width: 100px;
        max-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .push_rate ul li img {
        width: 25vw;
    }

    span.countdown {
        text-align: center;
        width: 100%;
        display: block;
        font-size: 0.85em;
        margin-bottom: 0.7em;
    }

    .submit button {
        margin-bottom: 15px;
    }

    .list-view span {
        margin-right: .4em;
        line-height: normal;
    }

    .bottom-button-group {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 10px;
    }

    .button-group-login {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .button-group-login button {
        padding: 0.5em 0.7em;
        margin: 0 0.5em .5em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 0;
        color: #fff;
    }

    .button-group-login button.google {
        background: #DD4B39;
    }

    .button-group-login button.facebook {
        background: #1976D2;
    }

    .button-group-login button img {
        margin-right: .2em;
    }
    .md-field {
        min-height: 53px;
    }

    @media screen and (min-width: 461px) and (max-width: 768px) {
        .success-text {
            font-size: 17px;
        }

        .social {
            padding: 10px;
        }

        .success-text-secondary {
            font-size: 13px;
        }

        .push_rate {
            margin-bottom: 5px;
        }

        .comment-button {
            margin-bottom: 0;
        }

        .success-message {
            font-size: 13px;
        }

        .push_rate ul li a {
            width: 25vw;
            height: 25vw;
        }

        .push_rate ul li a img {
            width: 22vw;
        }

        .btn.list-view {
            font-size: 1em;
            padding: 0.6em;
            display: none;
        }

        .place_img {
            width: 4em;
            height: 4em;
            margin: 0.5em auto 0.5em;
        }

        span.countdown {
            margin-bottom: 0em;
        }
    }


    @media screen and (max-width: 768px) {


        .vote-screen,
        .face-rate {
            height: auto;
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            transition: all .5s ease-in-out;
        }

        .place,
        .place_name,
        .question,
        .push_rate,
        .success-message {
            flex: none;
        }

        .place_img {
            width: 2.5em;
            height: 2.5em;
            margin: 0.25em auto .5em;
        }

        .place_img img {
            min-width: 2.5em;
            min-height: 2.5em;
        }

        .place_name,
        .question {
            font-size: .9em;
            padding-left: 15px;
            padding-right: 15px;
        }

        .push_rate ul li {
            margin: 0 .5vw;
        }

        .push_rate ul li a {
            width: 20vw;
            height: 20vw;
        }

        .push_rate ul li.active.cool {
            box-shadow: inset 0 0 0 0.2em #209400
        }

        .push_rate ul li.active.soso {
            box-shadow: inset 0 0 0 0.2em #ffc800
        }

        .push_rate ul li.active.meh {
            box-shadow: inset 0 0 0 0.2em #e01300
        }

        .push_rate ul li a img {
            width: 17.5vw;
        }

        .success-text {
            font-size: 14px;
            margin-bottom: 7px;
        }

        .success-text-secondary {
            font-size: 10px;
        }

        .face-rate .comment-wrap button {
            margin-top: 0;
            margin-bottom: 0;
        }

        .face-rate .comment-wrap button,
        .face-rate .submit button {
            font-size: 0.85em;
            min-height: 42px;
            padding: 0;
            margin-top: 10px;
        }

        .face-rate .submit button {
            margin-top: 10px;
        }

        .social h6 {
            font-size: 14px;
        }

        .social {
            margin-top: 10px;
            font-size: .9em;
        }


    }
    @media screen and (max-width: 426px) {
        .logo {
            margin-top: 64px;
        }
        .place_img {
            width: 64px;
            height: 64px;
        }
        .md-helper-text {
            font-size: 12px !important;
        }
    }
    @media screen and (max-width: 376px) {
        .custom-control {
            line-height: 20px;
            text-align: start;
        }
        .md-helper-text {
            text-align: start;
            line-height: 14px;
        }
        .custom-modal .btn.btn-primary {
            width: 100%
        }
        .feedback-text {
            line-height: 24px;
            padding-left: 0;
        }
    }

</style>
